import { Label } from '../atoms/label';
import messageConst from '../../const/messageConst';
import { QrReader } from "../atoms/qrReader";
import { useEffect, useRef, useState } from "react";

export const RoomQrReader = (props) => {
    const {
        id,
        labelClassName,
        wrapClassName,
        label,
        value,
        width,
        height,
        interval,
        onRead = () => { }
    } = props;

    const getDisplayRoomNo = (value) => {
        try {
            if (value && /^[0-9]+$/.test(value)) {
                // 5桁目以上を削除し、先頭の0を削除
                return value.substring(value.length - 4).replace(/^0+/g, '');
            }
        } catch { }
        return '';
    };

    const hiddenRef = useRef(null);
    const [roomNo, setRoomNo] = useState(getDisplayRoomNo(value));
    const [isShowReader, setIsShowReader] = useState(false);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        hiddenRef.current.value = value;
    }, []);

    const handleClick = () => {
        hiddenRef.current.value = '';
        setRoomNo('');
        setIsShowReader(true);
        setHasError(false);
        onRead();
    }

    const handleRead = value => {
        // リーダーを非表示
        setIsShowReader(false);

        if (value && typeof value === 'string') {
            const readRoomNo = getRoomNo(value);
            if (readRoomNo) {
                hiddenRef.current.value = readRoomNo;
                setRoomNo(getDisplayRoomNo(readRoomNo));
                setHasError(false);
                onRead();
                return;
            }
        }
        setHasError(true);
        console.error('Invalid qr is read', value);
    };

    const getRoomNo = (value) => {
        try {
            const roomNo = atob(decryptRoomValue(getQueryParams(value)['room']));
            if (roomNo) {
                return roomNo;
            } else {
                return '';
            }
        } catch {
            return '';
        }
    };

    const decryptRoomValue = (value) => {
        if (!value || typeof value !== 'string') {
            return '';
        }
        // '='を追加し、'_'を'/'、'-'を'+'に置換
        while (value.length % 4 !== 0) {
            value += '=';
        }
        return value.replace(/_/g, '/').replace(/-/g, '+');
    };

    const getQueryParams = (url) => {
        const queries = {};
        if (url && typeof url === 'string' && url.indexOf('?') > 0) {
            url.split('?')[1].split('&').map(value => value.split('=')).forEach(value => queries[value[0]] = value[1]);
        }
        return queries;
    };

    return (<div className={wrapClassName}>
        <Label label={label} className={labelClassName} />
        <Label label={messageConst.ESTHETIC_QR_NOTICE} className={'annotationMessage2'} />
        <div>
            <button type="button" className="btnToConfirmNoMargin" style={{ width: '100%' }} onClick={() => handleClick()}>
                二次元コードを読み取る
            </button>
            {roomNo ? (
                <div>
                    <Label label={messageConst.ESTHETIC_QR_SUCCESS} className={labelClassName} style={{ textAlign: 'center' }} />
                    <Label label={roomNo} className={labelClassName} style={{ textAlign: 'center', fontSize: '2rem' }} />
                </div>
            ) : (
                <Label label={messageConst.ESTHETIC_QR_DEFAULT} className={labelClassName} style={{ textAlign: 'center' }} />
            )}
            {hasError ? (
                <Label label={messageConst.ESTHETIC_QR_INVALID} className={labelClassName} style={{ color: 'red' }} />
            ) : (<></>)}
        </div>
        {isShowReader ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <QrReader
                    width={width}
                    height={height}
                    interval={interval}
                    onRead={value => handleRead(value)} />
            </div>
        ) : (<></>)}
        <input ref={hiddenRef} id={id} type="hidden" />
    </div>);
};
